import {
  ADAPTATION_COLORS,
  ADAPTATION_OVERLAY_TYPE,
  ADAPTATION_SOURCES,
  VisibleLayers,
  type AdaptationCode,
} from '~/constants'
import { useAppStore, usePMTiles } from '~/hooks'
import { Layer, Source } from 'react-map-gl/maplibre'
import type { FilterSpecification } from 'maplibre-gl'

export function AdaptationLayer() {
  const { sources, layerInfo } = usePMTiles()
  const { layerVisibility, adaptation, dataset } = useAppStore()

  const visibility: 'visible' | 'none' =
    dataset !== 'waves' && layerVisibility[VisibleLayers.ADAPTATION] ? 'visible' : 'none'

  const filter = [
    '==',
    ['get', 'adaptation'],
    ADAPTATION_OVERLAY_TYPE[adaptation as AdaptationCode],
  ] as FilterSpecification

  if (!layerInfo) return null

  return (
    <>
      {ADAPTATION_SOURCES.map((source) => {
        const url = sources[source]
        const sourceLayer = layerInfo[source]?.[0]?.layer
        if (!url || !sourceLayer) return null

        const layout = { visibility }

        return (
          <Source key={source} id={source} type="vector" url={`pmtiles://${url}`}>
            <Layer
              id={`${source}-line`}
              type="line"
              source={source}
              source-layer={sourceLayer}
              layout={layout}
              filter={filter}
              paint={{
                'line-color': ADAPTATION_COLORS.base,
                'line-width': 4,
                'line-opacity': 0.95,
              }}
            />
          </Source>
        )
      })}
    </>
  )
}
